export enum ReportLoadStatus {
  NO_FILE_CHOSEN,
  REQUEST_IN_PROGRESS,
  REPORT_LOADED,
  ERROR_LOADING_REPORT,
}
